import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from '@base-ui/react/autocomplete';
import { Icon } from '@petsmart-ui/sparky';
import type { ComponentProps } from 'react';
import type { AssistedResultItem, SearchResultItem } from '../../../search.types';
type SearchResultAssistButtonClickHandler = NonNullable<ComponentProps<typeof Autocomplete.Item>['onClick']>;
type SearchResultAssistButtonMouseUpHandler = NonNullable<ComponentProps<typeof Autocomplete.Item>['onMouseUp']>;
type SearchResultAssistButtonProps = {
  onResult: (result: SearchResultItem) => void;
  result: AssistedResultItem;
};
export function SearchResultAssistButton(t0) {
  const $ = _c(11);
  const {
    onResult,
    result
  } = t0;
  let t1;
  if ($[0] !== onResult || $[1] !== result) {
    t1 = event => {
      event.preventBaseUIHandler();
      onResult(result);
    };
    $[0] = onResult;
    $[1] = result;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  const handleMouseUp = _temp;
  const t2 = `Complete search with ${result.item.label}`;
  const t3 = `Complete search with ${result.item.label}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="navigation-arrow" aria-hidden="true" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <button aria-label={t3} className="header-search__assisted-button" tabIndex={-1} type="button">{t4}</button>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== handleClick || $[7] !== result || $[8] !== t2 || $[9] !== t5) {
    t6 = <Autocomplete.Item aria-label={t2} className="header-search__assisted-cell" onClick={handleClick} onMouseUp={handleMouseUp} tabIndex={-1} value={result}>{t5}</Autocomplete.Item>;
    $[6] = handleClick;
    $[7] = result;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(event_0) {
  event_0.preventBaseUIHandler();
}